import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconTaskListSquare$1 = /*@__PURE__*/ proxyCustomElement(class WppIconTaskListSquare extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-task-list-square", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M10.3889 7.86111C10.3889 7.53895 10.6501 7.27778 10.9722 7.27778H13.6944C14.0166 7.27778 14.2778 7.53895 14.2778 7.86111C14.2778 8.18328 14.0166 8.44444 13.6944 8.44444H10.9722C10.6501 8.44444 10.3889 8.18328 10.3889 7.86111ZM10.9723 11.5556C10.6501 11.5556 10.3889 11.8167 10.3889 12.1389C10.3889 12.4611 10.6501 12.7222 10.9723 12.7222H13.6944C14.0166 12.7222 14.2777 12.4611 14.2777 12.1389C14.2777 11.8167 14.0166 11.5556 13.6944 11.5556H10.9723ZM9.05137 7.49581C9.27917 7.26801 9.27917 6.89866 9.05137 6.67085C8.82356 6.44305 8.45422 6.44305 8.22641 6.67085L7.08333 7.81393L6.71803 7.44863C6.49023 7.22083 6.12088 7.22083 5.89308 7.44863C5.66527 7.67644 5.66527 8.04578 5.89308 8.27359L6.67085 9.05137C6.89866 9.27917 7.26801 9.27917 7.49581 9.05137L9.05137 7.49581ZM9.05137 10.9486C9.27917 11.1764 9.27917 11.5458 9.05137 11.7736L7.49581 13.3291C7.26801 13.557 6.89866 13.557 6.67085 13.3291L5.89308 12.5514C5.66527 12.3236 5.66527 11.9542 5.89308 11.7264C6.12088 11.4986 6.49023 11.4986 6.71803 11.7264L7.08333 12.0917L8.22641 10.9486C8.45422 10.7208 8.82356 10.7208 9.05137 10.9486ZM5.52778 3C4.13172 3 3 4.13172 3 5.52778V14.4722C3 15.8683 4.13172 17 5.52778 17H14.4722C15.8683 17 17 15.8683 17 14.4722V5.52778C17 4.13172 15.8683 3 14.4722 3H5.52778ZM4.16667 5.52778C4.16667 4.77606 4.77606 4.16667 5.52778 4.16667H14.4722C15.2239 4.16667 15.8333 4.77606 15.8333 5.52778V14.4722C15.8333 15.2239 15.2239 15.8333 14.4722 15.8333H5.52778C4.77606 15.8333 4.16667 15.2239 4.16667 14.4722V5.52778Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-task-list-square-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-task-list-square", "wpp-icon-task-list-square-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-task-list-square-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-task-list-square-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconTaskListSquare$1);
      }
      break;
  } });
}

const WppIconTaskListSquare = WppIconTaskListSquare$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconTaskListSquare, defineCustomElement };
